const EdDonDropdown = ({ setSelectedContainerId, containers }) => {
  return (
    <select
      className="form-control tall-select"
      onChange={setSelectedContainerId}
    >
      <option value="Reset">Pick a To-Go container</option>
      {containers.map((container) => (
        <option key={container.id} value={container.id}>
          {window.location.pathname == "/togo-don"
            ? container.remote_product_id
            : container.item_description}
        </option>
      ))}
    </select>
  )
}

EdDonDropdown.defaultProps = {
  containers: [],
}

export default EdDonDropdown
